module.exports = __webpack_public_path__ + "media/images/icon_occupation-c39864963f3709641706adc7ff0154c9.png";